import { DashboardFigure } from "@components/Dashboards/shell";

import { useTotalTenantsStatQuery } from "./TotalTenantsStat.g";

type Props = {
  onClick?: () => void;
  prominent?: boolean;
};

export const TotalTenantsStat = ({ onClick, prominent }: Props) => {
  const { data, isLoading } = useTotalTenantsStatQuery();

  const tenantCount = data?.clients?.totalCount ?? 0;

  return (
    <DashboardFigure
      prominent={prominent}
      label="Total tenants"
      value={tenantCount.toString()}
      isLoading={isLoading}
      onClick={onClick}
    />
  );
};
